import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorCodeHelper } from '@app/core/models/error-codeHelper';
import { GroupTypeModel } from '@app/core/models/groups/group-type.model';
import { GroupModel } from '@app/core/models/groups/group.model';
import { WorkflowDetailModel } from '@app/core/models/workflows/workflow-detail.model';
import { WorkflowStage } from '@app/core/models/workflows/workflow-stage';
import { WorkflowPromotionService } from '@app/core/services/workflowPromotion.service';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'app-workflow-promotion-detail',
  templateUrl: './workflow-promotion-detail.component.html',
  styleUrls: ['./workflow-promotion-detail.component.scss']
})
export class WorkflowPromotionDetailComponent implements OnInit, OnDestroy {

  unsubscribe$: Subject<boolean> = new Subject<boolean>();

  operationalGroupSelectedItem: GroupModel[];
  displayComptabilityGroup: false;

  constructor(
    private workflowpromotionService: WorkflowPromotionService,
    private router: Router,
    private errorCodeHelper: ErrorCodeHelper) {
  }

  ngOnInit(): void {
  }

  stageValidationGroupFilter = (group: GroupModel) => {
    return group.TypeId === GroupTypeModel.PPR_VALIDATION && group.IsActive;
  }

  operationalGroupFilter = (group: GroupModel) => {
    return group.TypeId === GroupTypeModel.OPERATIONAL && group.IsActive && group.CanCreateInPPR === true;
  }

  createWorkflow = (workflowDetail: WorkflowDetailModel): Observable<any> => {
    return this.workflowpromotionService.createWorkflow(workflowDetail);
  }

  updateWorkflow = (workflowDetail: WorkflowDetailModel): Observable<any> => {
    return this.workflowpromotionService.updateWorkflow(workflowDetail);
  }

  activateWorkflow = (workflowId: number): Observable<any> => {
    return this.workflowpromotionService.activateWorkflow(workflowId);
  }

  deactivateWorkflow = (workflowId: number): Observable<any> => {
    return this.workflowpromotionService.deactivateWorkflow(workflowId);
  }

  validStages = (workflowStages: WorkflowStage[]): string => {
    if (!workflowStages.length) {
      return this.errorCodeHelper.getErrorMessage('WFL008');
    }

    return null;
  }


  goBackToWorkflowList = () => {
    this.router.navigate(['administration/workflowsPromotion'])
  }

  ngOnDestroy() {
    this.unsubscribe$.next(true);
  }

}
